const accountDataPush = (data: any) => {
  //@ts-ignore
  if (window.digitalData) {
    let result: any = {
      userFlag: data.hasExportAccount
        ? "roi|is-eligible"
        : "roi|is-not-eligible",
    };
    //@ts-ignore
    digitalData.push(result);
  }
};

export default accountDataPush;
